import { render, staticRenderFns } from "./TheGlobalTopBanner.vue?vue&type=template&id=3a87b1de&scoped=true&"
import script from "./TheGlobalTopBanner.vue?vue&type=script&lang=js&"
export * from "./TheGlobalTopBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheGlobalTopBanner.vue?vue&type=style&index=0&id=3a87b1de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87b1de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VFlex,VIcon,VLayout})
